module.exports = __webpack_public_path__ + "img/thailand.6be4bfc5.png";